import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './InputGroup.module.scss';

type InputGroupProps = {
  title: string;
  description: string;
  children: ReactNode;
};

const InputGroup = ({ title, description, children }: InputGroupProps) => {
  return (
    <div className={classes.groupBox}>
      <TitleWithDescription
        title={title}
        description={description}
        titleFont="body-14-bold"
      />
      <div>{children}</div>
    </div>
  );
};

export { InputGroup };
